import styled from 'styled-components'

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  border-top: 2px solid #f0f0f0;
  padding: 10px 0;
`
